import React from 'react';
import { Link } from 'react-router-dom';
import SocialIcons from './SocialIcons';

const Footer = () => {
  return (
    <footer className="bg-white py-8">
      {/* Divider Section */}
      <div className="bg-gradient-to-r from-pink-600 to-pink-700 py-8 mb-16">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">Ready to Get Started?</h3>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Let's discuss your next project. Contact us for a free consultation and quotation.
          </p>
          <div className="flex justify-center">
            <Link to="/contact" className="px-8 py-4 bg-white text-pink-600 rounded-full font-semibold hover:bg-pink-50 transition-colors duration-300">
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Company Information */}
          <div className="md:col-span-1">
            {/* Logo */}
            <div className="mb-6">
              <img src="/assets/logo/LEMA_LOGO.png" alt="LEMASX Logo" className="h-16 w-auto" />
            </div>
            
            {/* Company Name */}
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              LEMASX Technology Co., Ltd
            </h3>
            
            {/* Contact Details */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
                <span className="text-gray-700">+84 965 985 960</span>
              </div>
              
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
                <span className="text-gray-700">+84 338 613 038</span>
              </div>
              
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                <span className="text-gray-700">contact-us@lemasx.com</span>
              </div>
              
              <div className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-red-500 mt-1" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
                <span className="text-gray-700 text-sm">
                  No.22/376 Khuong Dinh Street, Khuong Dinh Ward, Hanoi City, Vietnam
                </span>
              </div>
            </div>
          </div>

          {/* CAPABILITIES */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <h4 className="text-lg font-bold text-gray-900 uppercase mb-2">Capabilities</h4>
              <div className="w-12 h-0.5 bg-gray-300"></div>
            </div>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">CNC Machining</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">Sheet Metal</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">3D Printing</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">Injection Molding</a></li>
            </ul>
          </div>

          {/* ARTICLES */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <h4 className="text-lg font-bold text-gray-900 uppercase mb-2">Articles</h4>
              <div className="w-12 h-0.5 bg-gray-300"></div>
            </div>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-gray-600 hover:text-pink-600 transition-colors">Blog</Link></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">News</a></li>
            </ul>
          </div>

          {/* ABOUT */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <h4 className="text-lg font-bold text-gray-900 uppercase mb-2">About</h4>
              <div className="w-12 h-0.5 bg-gray-300"></div>
            </div>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">Our Vision</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">Our Value</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">Mission</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-600 transition-colors">Core Teams</a></li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-gray-200 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              Copyright © 2024 LEMASX Technology Co., Ltd. All rights reserved.
            </p>
            {/* Social Icons from database */}
            <div className="flex items-center gap-2">
              <SocialIcons compact />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
